import axios from 'axios';
import CONSTANTS from '../constants';
import AppService from "./appService";
import CacheService from './cacheService';
import PosHelper from '../helpers/pos';

export default {
    getCategories,
    getProducts,
    createOrder,
    getOrder,
    getConfig
};

async function getCategories(status = 'all') {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.POS.CATEGORIES}?status=${status}`, {
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}

async function getProducts(params) {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.POS.PRODUCTS}`, {
        params: params,
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}

async function createOrder(params) {
    params.totals = PosHelper.getTotalsFromCart(params.cart);
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.post(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.POS.ORDERS}`, params, {
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}

async function getOrder(orderId) {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.POS.ORDERS}/${orderId}`, {
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}

async function getConfig(siteId) {
    let newAccessToken = await AppService.refreshAccessToken();
    return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.POS.CONFIG}`, {
        params: {site_id: siteId},
        headers: {
            'Business-Name': CacheService.getToken().bname,
            'Access-Token': newAccessToken
        }});
}



// WEBPACK FOOTER //
// ./src/services/posService.js